import React, { useEffect } from 'react';
import { useOnboardingViewport } from '../shared/useViewport';

export const PaymentSuccessScreen = ({ refreshUser, user, setStep }) => {
  const vp = useOnboardingViewport();

  useEffect(() => {
    let isMounted = true;
    let pollInterval = null;
    const startTime = Date.now();
    const MAX_POLL_DURATION = 20000; // 20 seconds

    // 1. Reactive Check: If the user object already shows active subscription, redirect immediately
    const isActive = user?.has_active_subscription === true;
    if (isActive) {
      window.history.replaceState({}, "", "/");
      setStep("home");
      return;
    }

    // 2. Polling Loop: Periodically refresh user state
    pollInterval = setInterval(async () => {
      if (!isMounted) return;



      // Check for timeout
      if (Date.now() - startTime > MAX_POLL_DURATION) {
        if (pollInterval) clearInterval(pollInterval);
        return;
      }

      await refreshUser();
    }, 2000);

    return () => {
      isMounted = false;
      if (pollInterval) clearInterval(pollInterval);
    };
  }, [refreshUser]); // We don't include 'user' here to avoid restarting the interval

  // 3. Effect: React to user state changes driven by the polling
  useEffect(() => {
    const isActive = user?.has_active_subscription === true;
    if (isActive) {
      window.history.replaceState({}, "", "/");
      setStep("home");
    }
  }, [user]);

  return (
    <div style={{ 
      textAlign: 'center', 
      marginTop: '40px',
      padding: vp.sp(20, 30, 40),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '24px'
    }}>
      <div style={{
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        background: '#F0FDFB',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '10px'
      }}>
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#14B8A6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>
      
      <h1 style={{ fontSize: '32px', fontWeight: '900', color: '#0F172A' }}>
        Payment Successful!
      </h1>
      
      <p style={{ fontSize: '18px', color: '#64748B', fontWeight: '500', maxWidth: '400px', lineHeight: 1.5 }}>
        Thank you for subscribing. We're activating your account now. You'll be redirected to your training in a moment...
      </p>
      
      <div style={{ 
        width: '40px', 
        height: '40px', 
        border: '4px solid #F1F5F9', 
        borderTopColor: '#14B8A6', 
        borderRadius: '50%', 
        animation: 'spin 1s linear infinite',
        marginTop: '20px'
      }} />
      
      <style>{`
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
};
